import { frontendURL } from '../../../helper/URLHelper';
import KanbanView from './KanbanView.vue';
import { FEATURE_FLAGS } from '../../../featureFlags';
import {
  ROLES,
  CONVERSATION_PERMISSIONS,
} from 'dashboard/constants/permissions.js';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/kanban'),
    name: 'kanban',
    component: KanbanView,
    meta: {
      permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
      featureFlag: FEATURE_FLAGS.KANBAN,
    },
  },
];
